import { convertNumberToLetter } from '@repo/tools'
import { useLanguage } from './use-language'

export const useConvertNumber = () => {
  const language = useLanguage()
  return {
    convertNumberToLetter: (number: number) =>
      convertNumberToLetter(number, language as 'fa' | 'en'),
  }
}
